// ./src/utils/api/TemplateCategoryItemService.ts
import { gql } from "@apollo/client";
import { ApiService } from "./ApiService";
import { OpResult } from "@sdflc/api-helpers";
import { Pagination, SortItem } from "./commonApiTypes";
import { TemplateCategory } from "./TemplateCategoryService";
import { ContentBlock } from "./ContentBlockService";

// GraphQL queries
const TEMPLATE_CATEGORY_ITEM_LIST_QUERY = gql`
  query TemplateCategoryItemList(
    $filter: TemplateCategoryItemFilter
    $params: PaginationAndSorting
  ) {
    templateCategoryItemList(filter: $filter, params: $params) {
      code
      data {
        id
        templateCategoryId
        contentBlockId
        contentBlock {
          id
          name
          description
          contentType
          contentData
          fileUrl
          uploadedFileId
          blockSettings
        }
      }
      errors {
        name
        errors
        warnings
      }
    }
  }
`;

// Types

export interface TemplateCategoryItem {
  id?: string | undefined;
  templateCategoryId?: string | undefined;
  contentBlockId?: string | undefined;
  templateCategory?: TemplateCategory | undefined;
  contentBlock?: ContentBlock | undefined;
}

export interface TemplateCategoryItemFilter {
  id?: string[] | null | undefined;
  templateCategoryId?: string[] | null | undefined;
  contentBlockId?: string[] | null | undefined;
}

/**
 * Template Category Item service that handles all template category item-related API calls
 * Read-only operations: list
 */
export class TemplateCategoryItemService {
  /**
   * Get a list of template category items with optional filtering, pagination, and sorting
   */
  static async list(
    filter?: TemplateCategoryItemFilter,
    pagination?: Pagination,
    sortBy?: SortItem[]
  ): Promise<OpResult> {
    const result = await ApiService.executeQuery(
      TEMPLATE_CATEGORY_ITEM_LIST_QUERY,
      {
        filter: filter || {},
        params: {
          pagination: pagination || undefined,
          sortBy: sortBy || undefined,
        },
      }
    );
    return result;
  }
}
